import { Component, Input, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { Subscription } from "rxjs";
import { LoadingService } from "./services/loading.service";

@Component({
  selector: "app-loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.scss"],
})
export class LoadingComponent implements OnInit, OnDestroy {
  @Input() excludedUrls: string[] = [];
  isLoading = false;
  loadingMessage = "Carregando...";
  logoUrl = "";
  dots = [1, 2, 3, 4, 5];
  intervalId: any;
  progress$: any;
  private subscriptions = new Subscription();

  constructor(private loadingService: LoadingService) {
    this.logoUrl = window.location.href.includes("pdvup.") || localStorage.getItem('simular-pdvup') === 'true'
      ? "assets/images/pdv.UP-branco.png"
      : "assets/images/moda.UP-branco.svg";
    if (document.documentElement.classList.contains('tema-smart')) {
      this.logoUrl = "assets/images/Erp4mesmart_branco.png";
    } else if (document.documentElement.classList.contains('tema-intero')) {
      this.logoUrl = "assets/images/erpforme-intero-branco.png";
    }
  }

  ngOnInit(): void {
    this.loadingService.setExcludedUrls(this.excludedUrls);

    this.subscriptions.add(
      this.loadingService.loading$.subscribe((isLoading) => {
        this.isLoading = isLoading;
        if (!isLoading) {
          clearInterval(this.intervalId);
        }
      })
    );

    this.subscriptions.add(
      this.loadingService.progress$.subscribe((isProgress) => {
        this.progress$ = isProgress;
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["excludedUrls"]) {
      this.loadingService.setExcludedUrls(this.excludedUrls);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    clearInterval(this.intervalId);
  }

  showLoadingOverlay(message: string = "Carregando..."): void {
    this.loadingMessage = message;
  }

  hideLoadingOverlay(): void {
    clearInterval(this.intervalId);
  }
}
